var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v("Draggable FAQ List")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addFAQ.apply(null, arguments)
                }
              }
            },
            [_vm._v("Add")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
            [
              _c(
                "draggable",
                {
                  staticClass: "drag-view",
                  on: {
                    change: function($event) {
                      return _vm.changePosition()
                    }
                  },
                  model: {
                    value: _vm.questionList,
                    callback: function($$v) {
                      _vm.questionList = $$v
                    },
                    expression: "questionList"
                  }
                },
                [
                  _vm._l(_vm.questionList, function(text, index) {
                    return [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "ml-10 margin-faq card-body" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  title: "Edit FAQ",
                                  to: {
                                    name: "UpdateFAQ",
                                    params: { id: text.id }
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { key: index, staticClass: "faqQuestion" },
                                  [_vm._v(_vm._s(text.question))]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-danger deleteMedia deleteFaq",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteFAQ(text.id)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-trash",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        )
                      ])
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72f9366f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f9366f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/faq/DraggableListFAQ.vue
// module id = null
// module chunks = 